import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var KeyTagSVG = function KeyTagSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M33,13.828H24.828a2,2,0,0,0-1.414.586l-16,16a2,2,0,0,0,0,2.829l8.172,8.171a2,2,0,0,0,2.828,0l16-16A2,2,0,0,0,35,24V15.828A2,2,0,0,0,33,13.828Zm-5,9a2,2,0,1,1,2-2A2,2,0,0,1,28,22.828Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M17.586,35.3v-.533a2.9,2.9,0,0,1-2.558-1.688,1.049,1.049,0,0,1-.083-.394.745.745,0,0,1,.832-.762.884.884,0,0,1,.819.559,1.621,1.621,0,0,0,1.682.914c.952-.006,1.556-.374,1.556-1.06,0-.565-.522-.87-1.461-1.085l-.85-.191c-1.543-.349-2.533-1.187-2.533-2.431a2.624,2.624,0,0,1,2.6-2.552v-.546a.626.626,0,1,1,1.251,0v.546a2.756,2.756,0,0,1,2.45,1.733,1.172,1.172,0,0,1,.07.387c0,.413-.311.667-.781.667a.906.906,0,0,1-.844-.533,1.489,1.489,0,0,0-1.517-.883c-.908,0-1.435.394-1.435,1.01,0,.52.515.863,1.353,1.047l.8.184c1.682.375,2.647,1.193,2.647,2.457,0,1.58-1.257,2.456-2.742,2.627V35.3a.626.626,0,1,1-1.251,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M27.714,4.714A8.141,8.141,0,0,0,25,20.525v2.793a.418.418,0,0,0,.016.043.719.719,0,0,0,.083.174l1.738,1.737a2.038,2.038,0,0,1,0,2.878l-1.275,1.275L26.837,30.7a2.038,2.038,0,0,1,0,2.879l-1.275,1.275,2.152,2.152,2.632-2.632a.8.8,0,0,0,.084-.224V20.525A8.138,8.138,0,0,0,27.714,4.714Zm0,6.786a1.357,1.357,0,1,1,1.357-1.357A1.358,1.358,0,0,1,27.714,11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M27.714,2a10.848,10.848,0,0,0-5.428,20.245v1.073a3.238,3.238,0,0,0,.877,2.118l1.275,1.275-1.275,1.275a2.038,2.038,0,0,0,0,2.878l1.275,1.275-1.275,1.275a2.039,2.039,0,0,0,0,2.879l3.112,3.112a2.039,2.039,0,0,0,2.879,0l3.111-3.112a3.239,3.239,0,0,0,.878-2.118V22.245A10.848,10.848,0,0,0,27.714,2Zm5.429,16.909a8.145,8.145,0,0,1-2.714,1.616V34.15a.8.8,0,0,1-.084.224l-2.632,2.632-2.152-2.152,1.275-1.275a2.038,2.038,0,0,0,0-2.879l-1.275-1.275,1.275-1.275a2.038,2.038,0,0,0,0-2.878L25.1,23.535a.719.719,0,0,1-.083-.174A.418.418,0,0,1,25,23.318V20.525a8.151,8.151,0,1,1,8.143-1.616Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "DetailedIcon__foreground-color-fill",
    cx: "27.714",
    cy: "10.143",
    r: "1.357"
  }));
};
KeyTagSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
KeyTagSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Key Tag")
};
export default withDetailedIcon(KeyTagSVG);